import { render } from "./V0Style.vue?vue&type=template&id=49b791a8&scoped=true"
import script from "./V0Style.vue?vue&type=script&lang=js"
export * from "./V0Style.vue?vue&type=script&lang=js"

import "./V0Style.vue?vue&type=style&index=0&id=49b791a8&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bigdatadisplaysystem_php_master/front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49b791a8"]])

export default __exports__